export class ImageCropper {
    constructor(image, coordinates) {
        this.image = image;
        this.coordinates = coordinates;
        const maxSize = Math.max(image.width, image.height);
        this.safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));
        this.canvas = this.createCanvas();
        this.context = this.createContext();
    }
    static crop(image, coordinates) {
        const imageCropper = new ImageCropper(image, coordinates);
        imageCropper.draw();
        return imageCropper.getCanvas();
    }
    getCanvas() {
        return this.canvas;
    }
    draw() {
        const dx = this.safeArea / 2 - this.image.width * 0.5;
        const dy = this.safeArea / 2 - this.image.height * 0.5;
        this.context.drawImage(this.image, dx, dy);
        const data = this.getImageData();
        this.canvas.width = this.coordinates.width;
        this.canvas.height = this.coordinates.height;
        this.putImageData(data);
    }
    getImageData() {
        return this.context.getImageData(0, 0, this.safeArea, this.safeArea);
    }
    putImageData(data) {
        const x = Math.round(0 - this.safeArea / 2 + this.image.width * 0.5 - this.coordinates.xPixels);
        const y = Math.round(0 - this.safeArea / 2 + this.image.height * 0.5 - this.coordinates.yPixels);
        this.context.putImageData(data, x, y);
    }
    createCanvas() {
        const canvas = document.createElement('canvas');
        canvas.width = this.safeArea;
        canvas.height = this.safeArea;
        return canvas;
    }
    createContext() {
        const context = this.canvas.getContext('2d');
        if (!context) {
            throw new Error('Context doesn\'t exists');
        }
        return context;
    }
}
